import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldAlert } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function FloatingAssessmentCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setIsVisible(window.scrollY > 500);
        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (isAuthenticated || location.pathname.includes("/portal")) return null;

  return (
    <div
      className={`fixed bottom-4 right-4 z-40 transition-all duration-500 transform ${
        isVisible
          ? "translate-y-0 opacity-100"
          : "translate-y-20 opacity-0 pointer-events-none"
      }`}
    >
      <Button
        asChild
        className="bg-primary text-white hover:bg-primary/90 shadow-xl rounded-full pl-3 pr-5 py-5 border border-accent/30 group max-w-[200px]"
      >
        <Link to="/questionnaire">
          <div className="bg-accent/20 p-1.5 rounded-full mr-2 group-hover:bg-accent/30 transition-colors flex-shrink-0">
            <ShieldAlert className="w-4 h-4 text-accent" />
          </div>
          <div className="flex flex-col items-start text-left">
            <span className="text-[11px] font-bold uppercase tracking-wider text-accent leading-none">
              Free Diagnostic
            </span>
            <span className="text-sm font-medium leading-tight">
              Exposure Score™
            </span>
          </div>
          <ArrowRight className="ml-2 w-4 h-4 text-white/70 group-hover:translate-x-1 transition-transform flex-shrink-0" />
        </Link>
      </Button>
    </div>
  );
}
